import type { RequestHandler } from 'msw';
import { roadAuthorityScenario } from './road-authority';

// Each scenario: a list of MSW 2.x handlers that prepend onto the
// defaults in mswroutes.ts. Left-most handlers win, so a scenario's
// override of `GET /workorders` will replace the default handler's
// response for that endpoint.
//
// Add new scenarios as files in this directory, then import + map
// them here. Naming: kebab-case keyed by bug/feature reference
// (e.g. 'hkol-stop-42-missing', 'workorder-list-empty').
export const scenarios: Record<string, RequestHandler[]> = {
  // Seed scenario for the convention — proves the wiring works.
  // Remove or replace when a real scenario lands.
  example: [],
  // HK-1117: road-authority contractors, districts on stops, require_match 422.
  'road-authority': roadAuthorityScenario,
};
